const contractorConstants = {
  GET_CONTRACTORS: "GET_CONTRACTORS",
  GET_CONTRACTORS_SUCCESS: "GET_CONTRACTORS_SUCCESS",
  GET_CONTRACTORS_FAILURE: "GET_CONTRACTORS_FAILURE",
}

export default contractorConstants;
